import React from 'react'
import { useTranslation } from 'react-i18next'
import { maturiteLabels } from '../../utils/constants'
import { ListPagePill, MATURITY_PILL } from './ListPageCells'
import './ListPageTable.css'

interface ObjMTagProps {
  objectifM: string
}

const ObjMTag: React.FC<ObjMTagProps> = ({ objectifM }) => {
  const { i18n } = useTranslation()
  const lang = (i18n.language || 'en').startsWith('fr') ? 'fr' : 'en'
  const style = MATURITY_PILL[objectifM] ?? {
    bg: '#EAF0F0',
    color: '#5F7484',
  }
  const label = maturiteLabels[objectifM]?.[lang] || objectifM

  return (
    <ListPagePill
      label={label}
      bg={style.bg}
      color={style.color}
      size="sm"
    />
  )
}

export default ObjMTag
